// extracted by mini-css-extract-plugin
export var cardNumber = "Payment_cardNumber__xPz+3";
export var container = "Payment_container__+L9dp";
export var creditCard = "Payment_creditCard__2lABS";
export var edit = "Payment_edit__YqbUW";
export var error = "Payment_error__axlHq";
export var formContainer = "Payment_formContainer__ywV0M";
export var header = "Payment_header__Kpn3V";
export var label = "Payment_label__HG0gn";
export var md = "768px";
export var row = "Payment_row__ETtdS";
export var shared = "\"../../shared.module.css\"";